export default {
    common: {
        terms: "隐私政策与服务条款",
    },
};
